import { render } from "./social-settings.vue?vue&type=template&id=6e8ced43"
import script from "./social-settings.vue?vue&type=script&lang=js"
export * from "./social-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__